jQuery("document").ready(function($) {
  var overlaySearch = $("#overlay-search");
  var overlayMenu   = $("#overlay-menu");

  // trigger overlay menu on button click
  $(".trigger-overlay").on("click", function() {
      var targetOverlay = $(this).data("overlay");
      targetOverlay     = $("#overlay-" + targetOverlay);
      if ( targetOverlay.hasClass("open") ) {
        targetOverlay.removeClass("open");
      } else {
        $(".overlay.open").removeClass("open");
        targetOverlay.addClass("open");
      }
  });

  // search focus effect
  // adds a class for animating label
  $(".hero-search-filter-form-find").on("focus blur", function(e) {
      if( e.type == "focus" ){
        $(".hero-search-filter-form label").addClass("focus");
      }
      else{
        $(".hero-search-filter-form label").removeClass("focus");
      }
  });

  // Register/Login Toggle
  $("#btn-signin").on("click", function(e) {
    var btnRegister = $("#btn-register");
    var isExpanded = btnRegister.attr("aria-expanded");
    if ( isExpanded == "true" ) {
      btnRegister.trigger("click");
    }
  });
  $("#btn-register").on("click", function(e) {
    var btnSignin = $("#btn-signin");
    var isExpanded = btnSignin.attr("aria-expanded");
    if ( isExpanded == "true" ) {
      btnSignin.trigger("click");
    }
  });

  $('.hamburger').on('click', function() {
    $(this).toggleClass('is-active');
    $('.search-button2').removeClass('is-active');

  });

  $('.search-button2').on('click', function() {
    $(this).toggleClass('is-active');
  });

  $('.search-button2').on('click', function() {
    $('.hamburger').removeClass('is-active');
  });

  $('[data-address-term]').each(function() {
    var link = $(this);
    var cat  = link.data("address-term");
    var href = link.attr("href");
    href = href.replaceAll(cat, '');
    link.attr("href", href);
  });
});
